import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { LogoutRequest } from '../api/myaccount/logout/logoutrequest';
import { LogoutResponse, LogoutResponseDtoImpl } from '../api/myaccount/logout/logoutresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';

export class LogoutAPIProcessorImpl extends SixdeeCRBTAPIProcessor<LogoutRequest, LogoutResponse>
{

    execute(request: LogoutRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new LogoutResponseDtoImpl(APIFeatures.LOGOUT, "Logout Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new LogoutResponseDtoImpl(APIFeatures.LOGOUT, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
    
            this.getAPIFailure(new LogoutResponseDtoImpl(APIFeatures.LOGOUT, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/logoutapiprocessor.tsx